import {
  SAVING_FRESHSALES_REQUEST, SAVING_FRESHSALES_SUCCEDDED, SAVING_FRESHSALES_FAILED,
  FETCHING_FRESHSALES_INTEGRATION_REQUEST, FETCHING_FRESHSALES_INTEGRATION_SUCCEDDED, FETCHING_FRESHSALES_INTEGRATION_FAILED
} from '../actionTypes.jsx';
import { activatingIntegrationSuccedded, deactivatingIntegrationSuccedded, fetchingIntegrationSuccedded } from '../integrations';
import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const FRESHSALES_BASE_URL = `${apiUrl}/api/2.0/integrations/freshsales`;

export function authenticateAccount(request){
  return function (dispatch) {
    dispatch(authenticatingAccount(request));

    return axios({
      method: 'POST',
      url: FRESHSALES_BASE_URL,
      data: request
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}

function authenticatingAccount(){
  return {
    type: SAVING_FRESHSALES_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: SAVING_FRESHSALES_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: SAVING_FRESHSALES_FAILED,
    payload: error
  }
}

/**
* Fetch freshsales integration
*/
export function fetchFreshsalesIntegration() {
  return function (dispatch) {
    dispatch(fetchingFreshsalesIntegration());

    return axios({
      method: 'GET',
      url: FRESHSALES_BASE_URL
    })
    .then((response) => {
      dispatch(fetchingFreshsalesIntegrationSuccedded(response.data));
      dispatch(fetchingIntegrationSuccedded(response.data))
    })
    .catch(error =>
      dispatch(fetchingFreshsalesIntegrationFailed(error.errors))
    )
  }
}

function fetchingFreshsalesIntegration() {
  return {
    type: FETCHING_FRESHSALES_INTEGRATION_REQUEST,
    payload: {}
  }
}

function fetchingFreshsalesIntegrationSuccedded(json) {
  return {
    type: FETCHING_FRESHSALES_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function fetchingFreshsalesIntegrationFailed(error) {
  return {
    type: FETCHING_FRESHSALES_INTEGRATION_FAILED,
    payload: error
  }
}

